import { parseTenThousandths } from '@shared/utils/moneyArithmetic';
import type { UnsplitFigures, VatRateFigures } from '../types/dealerFundStatementPeriod.types';

export const sameAmount = (left: string, right: string): boolean => {
    const a = parseTenThousandths(left);
    const b = parseTenThousandths(right);
    return a !== null && b !== null && a === b;
};

export const sameUnsplit = (left: UnsplitFigures, right: UnsplitFigures): boolean =>
    left.postings === right.postings && sameAmount(left.gross, right.gross);

export const sameVatRates = (left: readonly VatRateFigures[], right: readonly VatRateFigures[]): boolean =>
    left.length === right.length &&
    left.every(
        (rate, index) =>
            rate.vatRatePercent === right[index].vatRatePercent &&
            sameAmount(rate.gross, right[index].gross) &&
            sameAmount(rate.vat, right[index].vat) &&
            sameAmount(rate.net, right[index].net),
    );
